import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { Observable, Subject, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { ErrorService } from '../../services/error.service';
import { OrderTemplateService } from '../../services/order-template.service';

@Directive({
	selector: '[appTemplateExists][formControlName],[appTemplateExists][formControl],[appTemplateExists][ngModel]',
	providers: [
		{
			provide: NG_ASYNC_VALIDATORS,
			useExisting: forwardRef(() => TemplateExistsValidatorDirective),
			multi: true
		}
	]
})
export class TemplateExistsValidatorDirective {

	@Input() custId: number; // Customer ID input parameter
	@Input() originalTemplateName: string; // Original template name for edit scenarios

	constructor(private _errorService: ErrorService,
				private _orderTemplateService: OrderTemplateService) {
	}

	validate(c: AbstractControl): Observable<{ [key: string]: any } | null> {
		if (!c.value || c.value.length === 0 || !this.custId) {
			return new Observable(observer => {
				observer.next(null);
				observer.complete();
			});
		}

		// If we're editing and the name matches the original, it's valid (no conflict)
		if (this.originalTemplateName && c.value === this.originalTemplateName) {
			return new Observable(observer => {
				observer.next(null); // null means no validation error
				observer.complete();
			});
		}

		// Use timer for debouncing and switchMap to cancel previous requests
		return timer(300).pipe(
			switchMap(() => this._orderTemplateService.checkIfTemplateNameExists(c.value, this.custId)),
			map(response => response ? {templateExists: true} : null)
		);
	}

}
